/**
 * Debug Logger - Production Safe
 * All console logging is DISABLED in production.
 * Use server-side error monitoring (Sentry/Crashlytics) instead.
 */

import monitoringService from '../services/monitoringService';

const isProduction = process.env.NODE_ENV === 'production';

const debugLogger = {
    // All logging disabled in production
    log: () => {},
    info: () => {},
    warn: () => {},
    
    error: (error) => {
        // Report errors to monitoring service for server-side logging
        if (isProduction) {
            try {
                monitoringService.logError(error instanceof Error ? error : new Error(String(error)), { level: 'error' });
            } catch (e) {
                // Fail silently if monitoring not available
            }
        }
    },

    critical: (error) => {
        // Always report critical errors
        if (isProduction) {
            try {
                monitoringService.logError(error instanceof Error ? error : new Error(String(error)), { level: 'critical' });
            } catch (e) {
                // Fail silently if monitoring not available
            }
        }
    },

    // Debug mode is DISABLED - always returns false
    isEnabled: () => false
};

export default debugLogger;
